import { object } from "valibot";
import { requireText } from "../utils/validation/base";
import { MAX_CHARACTERS_SM } from "../constants";

export type DnsRecord = {
  type: string;
  hostname: string;
  value: string;
};
export type EmailConfiguration = {
  domain: string;
  shared: boolean;
  fromName: string;
  fromEmail: string;
  isVerified: boolean;
  records: {
    sending: DnsRecord;
    bounce: DnsRecord;
  };
};

export const emailConfigurationSchema = object({
  domain: requireText(MAX_CHARACTERS_SM),
  fromName: requireText(MAX_CHARACTERS_SM),
  fromEmail: requireText(MAX_CHARACTERS_SM),
});
